import { Button, Card, Col, DatePicker, Empty, Form, Row } from "antd";
import VoucherChart from "./VoucherChart";
import HomePieChart from "./HomePieChart";
import { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";
import { CalendarIcon } from "../../assets";
import { useForm } from "antd/es/form/Form";
import Select from "../../components/Select";
import dayjs from "dayjs";
import { Loading } from "../../components";
import handleApiError from "../../utils/handleError";
import useUser from "../../hooks/useUser";

type Stats = {
  exam_vise_collection: Record<string, unknown>;
  total_ammount: number;
  total_exams: number;
  total_users: number;
  total_vouchers: number;
  used_vouchers: number;
};

const formLayout = { xs: 24, sm: 12, md: 12, lg: 6 };

const todayRange = {
  from: dayjs().startOf("day"),
  to: dayjs().endOf("day"),
};

const todayFilter = `/filter?from=${todayRange.from.unix()}&to=${todayRange.to.unix()}`;

export default function ATCHome() {
  const [form] = useForm();
  const [stats, setStats] = useState<Stats>();
  const [data, setData] = useState<any>([]);
  const [exams, setExams] = useState<any>([]);
  const [range, setRange] = useState<any>(todayRange);
  const [filter, setFilter] = useState<any>(todayFilter);
  const [loading, setLoading] = useState(false);

  const { user } = useUser();

  useEffect(() => {
    async function getData() {
      try {
        const res = await axiosClient.get(
          `/homepage/atc/${user?.atc.id}/stats${filter}`
        );
        setStats(res.data);
      } catch (error) {
        handleApiError(error);
      } finally {
        setLoading(false);
      }
    }
    if (user) getData();
  }, [user, filter]);

  useEffect(() => {
    async function getData() {
      try {
        setLoading(true);
        const res: any = await axiosClient.get("/exams/atc");
        setExams(res.data);
      } catch (error) {
        handleApiError(error);
      } finally {
        setLoading(false);
      }
    }
    getData();
  }, [user]);

  const checkAndSubmit = async () => {
    const values = await form.getFieldsValue();

    let isAllField = true;
    Object.keys(values).forEach((key) => {
      if (values[key] === undefined) {
        isAllField = false;
      }
    });
    if (isAllField) {
      form.submit();
    } else if (values.from && values.to) {
      return form.submit();
    }
  };

  const onFinish = async (values: any) => {
    const range: any = { from: values.from, to: values.to.endOf("day") };
    const idKey = "exam_id";
    const idValue = values.exam_id;
    const fromTimestamp = range.from.unix();
    const toTimestamp = range.to.unix();
    let filter = `/filter?from=${fromTimestamp}&to=${toTimestamp}`;
    if (idValue) filter += `&${idKey}=${idValue}`;
    setRange(range);
    setFilter(filter);
  };

  useEffect(() => {
    if (stats) {
      const data = Object.keys(stats.exam_vise_collection).map((key) => ({
        name: key,
        value: stats.exam_vise_collection[key],
      }));
      setData(data);
    }
  }, [stats]);

  if (loading) return <Loading />;

  if (!stats) return null;
  return (
    <div className="home_container">
      <div style={{ maxWidth: "1200px" }}>
        <Row gutter={[20, 20]}>
          <Col flex={1}>
            <Card bordered={false}>
              <h1>{stats.total_users}</h1>
              <h5>Total users</h5>
            </Card>
          </Col>
          <Col flex={1}>
            <Card bordered={false}>
              <h1>{stats.total_exams}</h1>
              <h5>Total exams</h5>
            </Card>
          </Col>
          <Col flex={1} className="voucher_chart">
            <VoucherChart
              data={[
                { name: "Assigned Vouchers", value: stats.total_vouchers },
                { name: "Used Vouchers", value: stats.used_vouchers },
              ]}
            />
          </Col>
        </Row>
      </div>

      <Form
        layout="vertical"
        form={form}
        onValuesChange={checkAndSubmit}
        onFinish={onFinish}
        initialValues={{ from: range.from, to: range.to }}
        className="home_form"
        style={{ marginTop: 30 }}
      >
        <Row gutter={[20, 20]}>
          <Col {...formLayout}>
            <Form.Item label="From" name="from">
              <DatePicker
                placeholder="DD/MM/YYYY"
                className="full-width"
                format="DD/MM/YYYY"
                suffixIcon={<CalendarIcon />}
              />
            </Form.Item>
          </Col>
          <Col {...formLayout}>
            <Form.Item label="To" name="to">
              <DatePicker
                placeholder="DD/MM/YYYY"
                className="full-width"
                format="DD/MM/YYYY"
                suffixIcon={<CalendarIcon />}
                // disabledDate={disabledDateTo}
              />
            </Form.Item>
          </Col>
          <Col {...formLayout}>
            <Select
              options={exams}
              placeholder={"Select Exam"}
              formItemProps={{
                name: "exam_id",
                label: " ",
              }}
            />
          </Col>
        </Row>
      </Form>
      <Button type="primary" style={{ backgroundColor: "#533031" }}>
        Total Amount Received: ${stats.total_ammount}
      </Button>

      <h5>Total Collection</h5>
      <Row justify="center">
        {data.length > 0 ? (
          <div className="home_pie-chart-2">
            <HomePieChart data={data} />
          </div>
        ) : (
          <Empty style={{ marginTop: 20 }} />
        )}
      </Row>
    </div>
  );
}
